"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyIdToRsaKeyPair = exports.rsaToKeyId = exports.assertInit = void 0;

const assertInit = prop => {
  // eslint-disable-next-line unicorn/no-null
  if (prop === null || prop === undefined) {
    throw new Error('BasisTheoryEncryption has not yet been properly initialized.');
  }

  return prop;
};

exports.assertInit = assertInit;

const rsaToKeyId = (pubKey, privKey) => `${pubKey}.${privKey}`;

exports.rsaToKeyId = rsaToKeyId;

const keyIdToRsaKeyPair = rsaString => {
  const parts = rsaString.split('.');
  return {
    publicKey: parts[0],
    privateKey: parts[1]
  };
};

exports.keyIdToRsaKeyPair = keyIdToRsaKeyPair;